import React, { useEffect, useState } from "react";
// import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { Divider, useMediaQuery } from "@mui/material";
import { Title, YouTube } from "@mui/icons-material";
import { FaInstagram, FaYoutube } from "react-icons/fa";
import { FaFacebook, FaTwitter, FaXTwitter } from "react-icons/fa6";
import { ArrowBack } from "@mui/icons-material"; // Import back arrow icon
import { useLocation, useNavigate, useParams } from "react-router-dom";
import blogImage from "../../assets/images/Interview Preperation.jpg";
import { featuredJobs, show_proper_words } from "../../utils/Constant";
import { s3baseUri } from "../../config/config";
import { useIds } from "../../hook/AdminContext";
import {
  _get_interview_list_blog_detail_api,
  get_hr_blog_etail_api,
  get_JD_temping_etail_api,
  get_training_blog_etail_api,
} from "../../DAL/partner/partners";
import { enqueueSnackbar } from "notistack";
import ReactPlayer from "react-player";
import DocumentPreview from "../interview/previewDocument";

export default function TempingBlogDetailPage() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const state = useLocation();
  console.log(state, "acvasgvxgaf");
  const location = useLocation();
  const { findId, setBreadCrumb } = useIds();
  const [dataapi, setDataApi] = useState();
  const params = useParams();

  const firstSegment = location.pathname.split("/")[1];
  const fetchCategories = async () => {
    const response = await get_JD_temping_etail_api(params.id);
    console.log(response, "responseresponseresponsevsss");
    if (response.code === 200) {
      setDataApi(response.temping_blog);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };
  console.log(dataapi, "dataapidataapidataapi");

  useEffect(() => {
    fetchCategories();
  }, []);

  const data = state.state;
  console.log(data, "assss");
  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      {
        name: `Temping`,
        path: `/${firstSegment}/temping`,
        active: false,
      },

      {
        name: `Temping  Blog Detail`,
        path: ``,
        active: true,
      },
    ]);
  }, []);
  const docs = dataapi?.documents?.map((docPath) => ({
    uri: s3baseUri + docPath,
  }));

  return (
    <div className="container-fluid justify-content-center mt-3">
      <div className="card shadow-md p-4 mt-3 mb-4 about-content">
        <h4 className="fw-bold mb-4">{dataapi?.title}</h4>

        {/* Wrap media and content inside same parent div */}
        <div className="content-wrapper mx-auto">
          <div className="media-wrapper mb-4">
            {dataapi?.video_url && dataapi.video_url !== "" ? (
              <ReactPlayer
                url={dataapi.video_url}
                controls
                width="100%" // react player container ko 100% de diya
                height="350px" // thodi height kam kari
                style={{ maxWidth: "600px", margin: "0 auto" }}
              />
            ) : (
              <img
                src={s3baseUri + dataapi?.image}
                alt="Blog"
                className="banner-image"
              />
            )}
          </div>

          <div
            className="editor-content"
            dangerouslySetInnerHTML={{
              __html: dataapi?.description,
            }}
          ></div>
        </div>
        {docs?.length > 0 && (
          <div className="documents-preview mt-4">
            <h5>Documents </h5>
            <DocumentPreview files={docs} dataapi={dataapi} />
          </div>
        )}
      </div>
    </div>
  );
}
